module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112021603.fea9d427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112021603.jpg
// module id = 38
// module chunks = 0